var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.419,
    x2: 0.601,
    y1: 0.002,
    x1: 0.98,
    id: "jira-original-wordmark-a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC",
    offset: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2684FF",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.46,
    x2: 0.566,
    y1: 0.003,
    x1: 1.006,
    id: "jira-original-wordmark-b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC",
    offset: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2684FF",
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.012,
    d: "M-.029 37h128v54h-128z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#253858",
    d: "M65.479 47.352h4.769v23.62c0 6.227-2.836 10.575-9.418 10.575-2.473 0-4.406-.41-5.734-.883v-4.523c1.449.59 3.199.882 4.949.882 4.047 0 5.434-2.351 5.434-5.757V47.352zm13.527-1.825c1.87 0 3.2 1.118 3.2 3.118 0 1.937-1.33 3.113-3.2 3.113-1.871 0-3.2-1.117-3.2-3.113 0-1.942 1.329-3.118 3.2-3.118zm-2.356 9.934h4.59v25.852h-4.59V55.46zm15.938 25.852h-4.465V55.46h4.465v4.523c1.57-3.054 4.226-5.23 9.422-4.937v4.348c-5.86-.586-9.422 1.117-9.422 6.64v15.278zm30.855-4.641c-1.691 3.406-4.89 5.168-8.996 5.168-7.066 0-10.629-5.817-10.629-13.453 0-7.285 3.746-13.457 11.172-13.457 3.864 0 6.883 1.703 8.453 5.054v-4.523h4.586v25.851h-4.586v-4.64zm-7.789 1.055c4.106 0 7.727-2.524 7.727-8.286v-2.054c0-5.758-3.32-8.285-7.246-8.285-5.13 0-7.785 3.289-7.785 9.285.058 6.226 2.593 9.34 7.304 9.34zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    d: "M41.51 42.063H20.62c0 5.054 4.226 9.167 9.417 9.167h3.867v3.583c0 5.054 4.227 9.167 9.418 9.167V43.824c0-.996-.785-1.762-1.812-1.762zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jira-original-wordmark-a)",
    d: "M31.186 52.168H10.295c0 5.055 4.226 9.168 9.418 9.168h3.863v3.64c0 5.055 4.227 9.169 9.422 9.169V53.93c0-.938-.785-1.762-1.812-1.762zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jira-original-wordmark-b)",
    d: "M20.861 62.332H-.029c0 5.055 4.226 9.168 9.418 9.168h3.863v3.582c0 5.055 4.227 9.168 9.422 9.168V64.098c0-1-.848-1.766-1.813-1.766zm0 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d7c240dc963919f88a8603f706e2a5af.svg";
export { ForwardRef as ReactComponent };